import React from 'react'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { connect } from 'react-redux'
import { useFormikContext, ErrorMessage } from 'formik'

import { getAdditionalDependenciesVisibility } from 'SRC/modules/categories/selectors'
import { getEquipmentVisibility } from 'SRC/modules/ads/equipment/selectors'

import { setAdditionalDependenciesVisibility } from 'SRC/modules/categories/actions'
import { setEquipmentVisibility } from 'SRC/modules/ads/equipment/actions'

import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

const MultiSelectSpecification = ({
	spec,
	additionalDependenciesVisibility,
	equipmentVisibility,
	updateRelatedSpecsVisibility,
	changeEquipmentGroupsVisibility,
	changeAdditionalDependentsVisibility,
	setAdditionalDependenciesVisibility,
	setEquipmentVisibility
}) => {
	const formik = useFormikContext()

	if (!formik.values || !Array.isArray(formik.values.specifications)) return null

	const value = formik.values.specifications[spec.index].value || []

	let specError = ''

	if (Array.isArray(formik.touched.specifications) && formik.touched.specifications[spec.index]) {
		specError = Array.isArray(formik.errors.specifications) ? formik.errors.specifications[spec.index] : ''
	}

  return (
    <Wrapper isError={specError}>
			<SelectDropdown
				id={`dropdown-spec-${spec.index}`}
				title={spec.label}
				isSearchable
				isMultiple
				isRequired={spec.isRequired}
				checkedItems={value}
				options={spec.options}
				onChange={async selectedOptions => {
					console.log('selectedoptions', selectedOptions)
					await formik.setFieldValue(`specifications.${spec.index}.value`, selectedOptions)

					if (!formik.touched.specifications || !formik.touched.specifications[spec.index]) {
						formik.setFieldTouched(`specifications.${spec.index}`, true)
					}

					updateRelatedSpecsVisibility(spec, selectedOptions)

					const equipmentVisibilityUpdated = { ...equipmentVisibility }
					changeEquipmentGroupsVisibility(spec, selectedOptions, equipmentVisibilityUpdated)
					setEquipmentVisibility(equipmentVisibilityUpdated)

					const additionalDependenciesVisibilityUpdated = { ...additionalDependenciesVisibility }
					changeAdditionalDependentsVisibility(spec, selectedOptions, additionalDependenciesVisibilityUpdated)
					setAdditionalDependenciesVisibility(additionalDependenciesVisibilityUpdated)
				}}
			/>

			<ErrorMessage
        name={`specifications.${spec.index}`}
        render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
      />
		</Wrapper>
  )
}

const mapStateToProps = (state, ownProps) => {
	return {
		equipmentVisibility: getEquipmentVisibility(state),
    additionalDependenciesVisibility: getAdditionalDependenciesVisibility(state)
	}
}

export default connect(mapStateToProps, {
	setAdditionalDependenciesVisibility,
	setEquipmentVisibility
})(MultiSelectSpecification)
